// language=GraphQL
export const ALL_WEBHOOK_LOGS_QUERY = `query Query($withOriginal: Boolean = false, $withOriginalOriginal: Boolean = false, $withOriginalOriginalOriginal: Boolean = false) {
  webhookLogs: webhookLogs {
    id
    type
    status
    url
    payload
    statusCode
    response
    executionTime
    retryCount
    original @include(if: $withOriginal) {
      id
      type
      status
      url
      payload
      statusCode
      response
      executionTime
      retryCount
      original @include(if: $withOriginalOriginal) {
        id
        type
        status
        url
        payload
        statusCode
        response
        executionTime
        retryCount
        original @include(if: $withOriginalOriginalOriginal) {
          id
          type
          status
          url
          payload
          statusCode
          response
          executionTime
          retryCount
        }
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_WEBHOOK_LOG_QUERY = `query Query($id: ID!, $withOriginal: Boolean = false, $withOriginalOriginal: Boolean = false, $withOriginalOriginalOriginal: Boolean = false) {
  webhookLog: webhookLog(id: $id) {
    id
    type
    status
    url
    payload
    statusCode
    response
    executionTime
    retryCount
    original @include(if: $withOriginal) {
      id
      type
      status
      url
      payload
      statusCode
      response
      executionTime
      retryCount
      original @include(if: $withOriginalOriginal) {
        id
        type
        status
        url
        payload
        statusCode
        response
        executionTime
        retryCount
        original @include(if: $withOriginalOriginalOriginal) {
          id
          type
          status
          url
          payload
          statusCode
          response
          executionTime
          retryCount
        }
      }
    }
  }
}`

// language=GraphQL
export const CREATE_WEBHOOK_LOG_MUTATION = `
  mutation Mutation($input: CreateWebhookLogInput, $withOriginal: Boolean = false, $withOriginalOriginal: Boolean = false, $withOriginalOriginalOriginal: Boolean = false) {
    webhookLog: createWebhookLog(input: $input) {
      id
      type
      status
      url
      payload
      statusCode
      response
      executionTime
      retryCount
      original @include(if: $withOriginal) {
        id
        type
        status
        url
        payload
        statusCode
        response
        executionTime
        retryCount
        original @include(if: $withOriginalOriginal) {
          id
          type
          status
          url
          payload
          statusCode
          response
          executionTime
          retryCount
          original @include(if: $withOriginalOriginalOriginal) {
            id
            type
            status
            url
            payload
            statusCode
            response
            executionTime
            retryCount
          }
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_WEBHOOK_LOG_MUTATION = `
  mutation Mutation($input: UpdateWebhookLogInput, $withOriginal: Boolean = false, $withOriginalOriginal: Boolean = false, $withOriginalOriginalOriginal: Boolean = false) {
    webhookLog: updateWebhookLog(input: $input) {
      id
      type
      status
      url
      payload
      statusCode
      response
      executionTime
      retryCount
      original @include(if: $withOriginal) {
        id
        type
        status
        url
        payload
        statusCode
        response
        executionTime
        retryCount
        original @include(if: $withOriginalOriginal) {
          id
          type
          status
          url
          payload
          statusCode
          response
          executionTime
          retryCount
          original @include(if: $withOriginalOriginalOriginal) {
            id
            type
            status
            url
            payload
            statusCode
            response
            executionTime
            retryCount
          }
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_WEBHOOK_LOG_MUTATION = `
  mutation Mutation($input: DeleteWebhookLogInput) {
    deleteWebhookLog(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_WEBHOOK_LOG_MUTATION = `
  mutation Mutation($input: DeleteWebhookLogInput) {
    forceDeleteWebhookLog(input: $input) {
      success
    }
  }`
// language=GraphQL
export const WEBHOOK_LOGS_DEPENDENTS_QUERY = `query Query($id: ID!, $withWebhookLogs: Boolean = false) {
  groupedDependents: webhookLogDependents(id: $id) {
    webhookLogs @include(if: $withWebhookLogs) {
      id
      type
      status
      url
      payload
      statusCode
      response
      executionTime
      retryCount
    }
  }
}`
